import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import router from './router';
import store from './store';

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../src/theme/theme.scss";
Vue.use(ElementUI);

// global_css
import './style.scss';

const originalPush: any = Router.prototype.push
Router.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err)
}

new Vue({
  router,
  store,
  render: (h) => {
    return h(App);
  },
}).$mount('#app')
